export default __webpack_public_path__ + "static/media/doctor.ab270d91.png";